import { c as _c } from "react/compiler-runtime";
import { Breadcrumbs, BreadcrumbsData } from '@systemeio/ui';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
interface BreadcrumbsProps {
  data: BreadcrumbsData[];
  isFetching?: boolean;
}
const BreadcrumbsDashboard = t0 => {
  const $ = _c(3);
  const {
    data,
    isFetching
  } = t0;
  let t1;
  if ($[0] !== data || $[1] !== isFetching) {
    t1 = <Breadcrumbs data={data} isFetching={isFetching} CustomBreadcrumbLinkItem={_temp} />;
    $[0] = data;
    $[1] = isFetching;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default BreadcrumbsDashboard;
function _temp(t0) {
  const {
    children,
    href
  } = t0;
  return <LinkWithoutPrefetch href={href}>{children}</LinkWithoutPrefetch>;
}